import React, { FC } from 'react';
import { TableRow, TableCell, makeStyles } from '@dxb-web-ui-framework/design-system';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { isFunction } from '@dxb-web-ui-framework/common/utils/Helper';
import { ColumnDef } from '../../types';

export interface TableGridRowProps {
  columnDefs: ColumnDef[];
  rowItemData: GenericObject;
  defaultCellRenderer: (rowData: GenericObject, columnDef: GenericObject) => any;
  isRowSelected?: (rowData: GenericObject) => boolean;
  onClickRow?: Function;
  isTableRowClickable?: boolean;
}

const useStyles = makeStyles(theme => ({
  selected: {
    backgroundColor: `${theme.palette.background.default} !important`,
  },
}));

const TableGridRow: FC<TableGridRowProps> = ({
  columnDefs,
  rowItemData,
  defaultCellRenderer,
  isRowSelected,
  onClickRow,
  isTableRowClickable,
}) => {
  const isSelected = () => {
    if (isRowSelected && isFunction(isRowSelected)) {
      return isRowSelected(rowItemData);
    } else {
      return false;
    }
  };

  const onClick = (e: any) => {
    if (isTableRowClickable) {
      onClickRow && onClickRow(e, rowItemData);
    }
  };

  const classes = useStyles({ isTableRowClickable });
  return (
    <TableRow
      onClick={onClick}
      selected={isSelected()}
      hover={isTableRowClickable}
      classes={{ selected: classes.selected }}>
      {columnDefs.map((columnDef, columnIndex) => {
        if (Boolean(columnDef.isHidden)) {
          return null;
        }

        return (
          <TableCell key={`TableCell-${columnDef.id}-${columnIndex}`} {...columnDef.cellProps}>
            {columnDef.cellRenderer
              ? columnDef.cellRenderer(rowItemData, columnDef)
              : defaultCellRenderer(rowItemData, columnDef)}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export { TableGridRow };
